import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import formikConnectedMultiItemSelect from '../../basics/ItemSelect/formikConnectedMultiItemSelect'
import multiItemSelect from '../../basics/ItemSelect/multiItemSelect'

const LANGUAGES = ['de-DE', 'en-EN']

/**********************************************************************
 * SelectLanguages
 **********************************************************************/
const SelectLanguages = multiItemSelect({
  multiSelect: true,
  useSuggestions: () => {
    const { t } = useTranslation()

    const [query, setQuery] = useState<string | null | undefined>('')

    const languages = useMemo(
      () => LANGUAGES.map((lang) => ({ uuid: lang, name: t('format.LANGUAGE', { code: lang }) })),
      [t]
    )

    const suggestions = useMemo(
      () => (query ? languages.filter(({ name }) => name.toLowerCase().includes(query.toLowerCase())) : languages),
      [languages, query]
    )

    return {
      query,
      setQuery,
      suggestions,
    }
  },
  renderSelectedItemComponent: ({ item }) => {
    const { t } = useTranslation()
    return t('format.LANGUAGE', { code: item.uuid })
  },
  renderItemDescription: (language) => language.name,
})

export default SelectLanguages

/**********************************************************************
 * SelectLanguagesFormik
 **********************************************************************/
export const SelectLanguagesFormik = formikConnectedMultiItemSelect({ component: SelectLanguages })
